import '../../styles/cv/header.scss'

// Language
import { useLanguage } from '../../context/language_context'


function Header() {

    const { language } = useLanguage()

    return (
        <header>

            <p>
                {language === 'fr'
                    ? 'qui_je_suis.exe'
                    : 'about_me.exe'}
            </p>

            <ul>
                <li>
                    {language === 'fr'
                        ? 'modifier |'
                        : 'edit |'}
                </li>

                <li>
                    {language === 'fr'
                        ? 'retour'
                        : 'back'}
                </li>
            </ul>

        </header>
    )
}

export default Header